import {
	EventInterface
} from '../vendor/splide.esm.js';

export function Expander(Splide, Components) {
	const {
		bind
	} = EventInterface(Splide);
	const {
		Move
	} = Components;
	const {
		list
	} = Components.Elements;

	let endCallback;

	function mount() {
		bind(list, 'transitionend', e => {
			if (e.target === list && endCallback) {
				// Removes the transition property
				cancel();

				// Calls the `done` callback
				endCallback();
			}
		});
	}

	function start(index, done) {

		Splide.root.querySelectorAll('.splide__slide.is-selected').forEach((element) => {
			element.classList.remove('is-selected');
		});

		Splide.root.querySelectorAll('.splide__slide')[index].classList.add('is-selected');

		setTimeout(function() {
			// Converts the index to the position
			const destination = Move.toPosition(index, true);

			// Applies the CSS transition
			list.style.transition = 'transform 375ms cubic-bezier(.44,.65,.07,1.01)';

			// Moves the carousel to the destination.
			Move.translate(destination);

			// Keeps the callback to invoke later.
			endCallback = done;
		}, 188);
	}

	// Required
	function cancel() {
		list.style.transition = '';
	}

	return {
		mount,
		start,
		cancel
	};
}
